import * as Sentry from "@sentry/react";
import { redactUrlSecrets } from "@opus-dt/shared-types";
import { loadEnv } from "./env";

let initialized = false;

/**
 * Spec 078 — a rota pública `/display/<token>` carrega o segredo NA URL, e o Sentry anexa
 * `location.href` (evento, breadcrumbs de navegação/fetch) por padrão. Sem isto, qualquer erro
 * numa TV manda um link de exibição válido e não revogado para o Sentry.
 */
/** Campos onde o Sentry guarda URL: navegação (`from`/`to`), fetch/xhr (`url`). */
const URL_FIELDS = ["url", "from", "to"] as const;

function scrubData(data: Record<string, unknown> | undefined): void {
  if (!data) return;
  for (const field of URL_FIELDS) {
    const value: unknown = data[field];
    if (typeof value === "string") data[field] = redactUrlSecrets(value);
  }
}

function scrubUrls<T>(event: T): T {
  const e = event as {
    request?: { url?: string };
    breadcrumbs?: Array<{ data?: Record<string, unknown> }>;
  };
  if (typeof e.request?.url === "string") e.request.url = redactUrlSecrets(e.request.url);
  for (const crumb of e.breadcrumbs ?? []) scrubData(crumb.data);
  return event;
}

export function initSentry(): void {
  if (initialized) return;
  const env = loadEnv();
  if (!env.VITE_SENTRY_DSN) return;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend: scrubUrls,
    beforeBreadcrumb: (crumb) => {
      scrubData(crumb.data);
      return crumb;
    },
  });
  initialized = true;
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
